<template>
  <div>
    <form @submit.prevent="getAudience(true)">
        <div class="panel panel-default">   
        <div class="panel-heading">
        <h3 class="panel-title">{{action}}</h3>
        </div>
        <div class="panel-body">
            <div class="row">
              <div class="col-md-12 col-lg-12 col-xs-12"> 
                <div class="form-group col-xs-6 col-sm-6 col-md-6">
                  <label for="name" class="required">Query Name</label>
                  <input type="text" v-model="gRowObj.query_name" class="form-control " id="query_name" placeholder="Query Name"  />
                  <span v-if="submitted && !$v.gRowObj.query_name.required" class="text-red pull-left">Please enter query name.</span>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-12 col-lg-12 col-xs-12">
                <div class="form-group col-xs-6 col-sm-6 col-md-6">
                <label for="name" class="required">Country</label>
                <treeselect 
                  id="country"
                  :clearable="false"
                  placeholder="--Choose a Country--"
                  :multiple="false" 
                  :options="countryList"
                  v-model="gRowObj.country_id" 
                />
                <span v-if="submitted && !$v.gRowObj.country_id.required" class="text-red pull-left">Please choose a country.</span>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-12 col-lg-12 col-xs-12">
                <div class="form-group col-xs-6 col-sm-6 col-md-6">
                  <label for="name">Folder Name</label>
                  <treeselect 
                    id="folder"
                    :clearable="true"
                    placeholder="--Choose a Folder--"
                    :multiple="false" 
                    :options="folderList"
                    v-model="gRowObj.audience_folder_id" 
                  />
                </div>
              </div>
            </div>  

            <div class="row">
              <div class="col-md-12 col-lg-12 col-xs-12">
                <div class="form-group col-xs-6 col-sm-6 col-md-6">
                  <label for="name" class="required">Paste the account IDs into the text box below, one per line</label>
                  <textarea style="height:270px;" class="form-control" v-model="accountId" id="account_id" />
                  <span v-if="submitted && !$v.accountId.required" class="text-red pull-left">Please enter account ids.</span>
                </div>
              </div>
            </div>

        </div>
        </div>
        <div class="action-button">
          <input type="submit" class="btn btn-primary" value="Get Audience"/>
        &nbsp; &nbsp;
          <button type="button" class="btn btn-primary"  @click="saveAudience" >{{gRowObj.id ? 'Update' : 'Save'}} Audience</button>
           &nbsp; &nbsp;
        <button type="button" class="btn btn-primary" @click="openModal()">Export Transcripts</button>
            &nbsp; &nbsp;
        <button type="button" class="btn btn-primary" @click="openModal(true)">Export GenAI Onboarding Transcript</button>
        </div>
    </form>
    <BlockUI v-if="loading"><i class="fa fa-cog fa-spin fa-3x fa-fw"></i><br/>Please wait...</BlockUI>
    <AudienceTable :audienceData="audienceData" :audienceCount="audienceCount" :showTable="false"/>
    <div class="modal-backdrop" v-if="showTranscriptModal" >
      <div class="modal modal-md" style="height: 230PX;max-width:600px">
        <header class="modal-header">
          <slot name="header">
            <h3>Get Transcripts</h3>
          </slot>
          <div class="modal-body">
            <slot name="body">
            <div class="form-horizontal">
              <div class="form-group">
                <label for="folderName" style="font-weight:500;text-align:left" class="col-sm-4 control-label required">Type #</label>
                <div class="col-sm-8" style="text-align: left;">
                  <input type="text" class="form-control" v-model="transcriptNumber"/>
                  <span v-if="submittedTransriptNumber && (!$v.transcriptNumber.required || !$v.transcriptNumber.minValue || !$v.transcriptNumber.maxValue)" class="text-red pull-right">Please enter a number between 1-100.</span>
                </div>
              </div>
              <div class="form-group pull-right" style="margin-right:3px;margin-top:20px;">
                <div class="col-sm-12">
                  <button type="button" class="btn btn-primary" @click="closeModal" >Cancel</button>
                  <button type="button" class="btn btn-primary" @click="exportTranscripts" >Submit</button>
                </div>
              </div>
            </div>
            </slot>
          </div>
        </header>
        <footer class="modal-footer"></footer>
      </div>
    </div>   
  </div>
</template>
<script>
import api from '../../../../utils/api'
import apinew from '../../../../utils/latestApi'
import { required, minValue, maxValue } from 'vuelidate/lib/validators'
import { getEnv } from '../../../../utils/utilities'
import AudienceTable from '../table'

export default {
  name: 'uploadForm',
  components: {
    AudienceTable
  },
  validations: {
    gRowObj: {
      country_id: { required },
      query_name: { required }
    },
    accountId: { required },
    transcriptNumber: { required, minValue: minValue(1), maxValue: maxValue(100) }
  },
  data () {
    return {
      gRowObj: {
        id: null,
        query_name: '',
        country_id: null,
        audience_folder_id: null,
        account_ids: [],
        query_type: ''
      },
      accountId: '',
      env: '',
      countryList: [],
      folderList: [],
      submitted: false,
      loading: false,
      action: 'Create Audience',
      audienceData: [],
      audienceCount: 0,
      transcriptNumber: '',
      submittedTransriptNumber: false,
      showTranscriptModal: false,
      accountIds: [],
      transcriptIds: [],
      isGenAITranscript: false
    }
  },
  async mounted () {
    this.loading = true
    this.env = await getEnv()
    await this.getCountryList()
    await this.fetchFolders()
    if (this.$route.query.queryId) {
      this.action = 'Update Audience'
      await this.fetchAudienceDetails(this.$route.query.queryId)
    }
    this.loading = false
  },
  methods: {
    openModal (isGenAITranscript = false) {
      this.submitted = true
      this.isGenAITranscript = isGenAITranscript
      this.$v.$touch()
      if (this.$v.gRowObj.$invalid || this.$v.accountId.$invalid) {
        return
      }
      this.showTranscriptModal = true
    },

    async exportTranscripts (e) {
      this.$v.$touch()
      this.submittedTransriptNumber = true
      console.log('v,', this.$v)
      if (this.$v.transcriptNumber.$invalid) {
        return
      }
      this.submittedTransriptNumber = false
      this.showTranscriptModal = false
      this.getAudience(false, this.transcriptNumber).then(() => {
        this.accountIds = this.transcriptIds.map(audience => audience.accountId)
        if (this.accountIds[0] === null) {
          this.transcriptNumber = ''
          return this.$swal({
            type: 'error',
            text: 'No audience found for the given criteria'
          })
        }
        this.uploadTranscripts()
      })
      this.transcriptNumber = ''
    },

    async uploadTranscripts () {
      let allAttributes = {
        queryName: this.gRowObj.query_name,
        countryId: this.gRowObj.country_id,
        country_name: this.countryList.find(item => item.id === this.gRowObj.country_id).label,
        needSampleData: false,
        numberOfTranscripts: this.transcriptNumber
      }
      let params = Object.entries(allAttributes).reduce((a, [k, v]) => { let val = (v == null || v === '' ? a : (a[k] = v, a)); return val }, {})
      params.criteria = {
        account_ids: this.accountId.split('\n').map(id => id.trim())
      }
      this.loading = true
      try {
        const response = await api.buildRequest(`/audience/exportTranscripts`, 'POST', { audience: this.accountIds, audienceName: this.gRowObj.query_name, params, countryName: this.env.country, isGenAITranscript: this.isGenAITranscript })
        this.loading = false
        this.$swal({
          type: 'success',
          html: response.data.payload.html ? response.data.payload.html : 'Exported transcripts successfully'
        })
      } catch (error) {
        this.loading = false
        this.$swal({
          type: 'error',
          text: error.response ? error.response.data.payload.message : 'An error occurred'
        })
      }
      this.isGenAITranscript = false
    },

    closeModal () {
      this.showTranscriptModal = false
      this.transcriptNumber = ''
    },

    async saveAudience () {
      this.submitted = true
      this.$v.$touch()
      if (this.$v.gRowObj.$invalid || this.$v.accountId.$invalid) {
        return
      }
      const ids = this.accountId.split('\n').map(id => id.trim())
      let criteria = {
        account_ids: ids.filter(v => v !== '')
      }
      const params = {
        id: this.gRowObj.id,
        query_name: this.gRowObj.query_name,
        country_id: this.gRowObj.country_id,
        country_name: this.countryList.find(item => item.id === this.gRowObj.country_id).label,
        criteria,
        query_type: 'Custom',
        audience_folder_id: this.gRowObj.audience_folder_id ? this.gRowObj.audience_folder_id : null
      }
      console.log('params', params)
      try {
        this.loading = true
        const response = await apinew.post(`audience-builder/${this.env.env}/queries/save`, params, { baseURL: this.env.baseURL })
        this.loading = false
        this.$swal({
          title: 'Success',
          type: 'success',
          text: response.data ? response.data.message : 'Audience uploaded successfully'
        }).then(() => {
          this.$router.push({ name: 'audience-builder/view' })
        })
      } catch (error) {
        this.loading = false
        if (error.response && error.response.status === 409) {
          this.$swal({
            type: 'error',
            title: 'Save Audience',
            text: 'Audience query with same name already exists'
          })
        } else {
          this.$swal({
            type: 'error',
            title: 'Save Audience',
            text: error.response.data.message ? error.response.data.message : 'An error occurred'
          })
        }
      }
    },

    async fetchAudienceDetails (id) {
      const params = {
        id: id
      }
      try {
        const response = await apinew.get(`audience-builder/${this.env.env}/queries`, { params: params, baseURL: this.env.baseURL })
        const updateQryData = response.data.data[0]
        this.gRowObj.id = updateQryData.id ? updateQryData.id : null
        this.gRowObj.query_name = updateQryData.query_name ? updateQryData.query_name : ''
        this.gRowObj.country_id = updateQryData.country_id ? updateQryData.country_id : null
        this.accountId = updateQryData.criteria ? updateQryData.criteria.account_ids.join('\n') : ''
        this.gRowObj.audience_folder_id = updateQryData.audience_folder_id ? updateQryData.audience_folder_id : null

        if (this.$route.query.action === 'copyAudience') {
          this.gRowObj.query_name = ''
          this.gRowObj.id = null
        }
      } catch (error) {
        this.loading = false
        this.$swal({
          title: 'Failure',
          type: 'error',
          text: error.response ? error.response.data.payload.message : 'An error occurred'
        })
      }
    },

    async fetchFolders () {
      this.loading = true
      try {
        const response = await api.buildRequest(`/audience/getAllFolders`, 'POST')
        this.folderList = response.data.payload.map(folder => {
          return { id: folder.id, label: folder.folder_name }
        })
        this.loading = false
      } catch (error) {
        this.loading = false
        this.$swal({
          type: 'error',
          text: error.response ? error.response.data.payload.message : 'An error occurred'
        })
      }
    },

    async getAudience (needSampleData = true, numberofTranscripts = 0) {
      this.submitted = true
      this.$v.$touch()
      if (this.$v.gRowObj.$invalid || this.$v.accountId.$invalid) {
        return
      }
      let allAttributes = {
        queryName: this.gRowObj.query_name,
        countryId: this.gRowObj.country_id,
        country_name: this.countryList.find(item => item.id === this.gRowObj.country_id).label,
        needSampleData,
        numberOfTranscripts: numberofTranscripts
      }
      let params = Object.entries(allAttributes).reduce((a, [k, v]) => { let val = (v == null || v === '' ? a : (a[k] = v, a)); return val }, {})
      params.criteria = {
        account_ids: this.accountId.split('\n').map(id => id.trim())
      }
      params.include_tnc_false_users = this.isGenAITranscript
      this.loading = true
      try {
        const response = await apinew.post(`audience-builder/${this.env.env}/users/re-engagement-audience`, params, { baseURL: this.env.baseURL })
        this.loading = false
        if (needSampleData) {
          this.audienceCount = response.data.totalCounts
        } else {
          this.transcriptIds = response.data.data.map(aud => { return {accountId: aud.accountId} })
          console.log('tr', this.transcriptIds)
        }
      } catch (error) {
        this.loading = false
        this.$swal({
          type: 'error',
          text: error.response ? error.response.data.payload.message : 'An error occurred'
        })
      }
    },

    async getCountryList () {
      try {
        const response = await api.buildRequest('getCountryList', 'POST')
        this.countryList = response.data.payload.map(item => { return { id: item.country_id, label: item.country_name } })
      } catch (error) {
        this.loading = false
        this.$swal({
          title: 'Failure',
          type: 'error',
          text: error.response ? error.response.data.payload.message : 'An error occurred'
        })
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// audienceUploadForm.vue?50f48b19